import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-content">
          <h1>Why Choose Escudero Electrical Contractors?</h1>
          <p className="subtitle">Benefits of Working With an Expert Team</p>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="benefits-container">
          <div className="benefit-card light">
            <h3>Satisfaction Guarantee</h3>
            <p>We back every job with a 100% satisfaction guarantee. Our commitment to quality ensures your electrical project is completed to the highest standards.</p>
          </div>
          
          <div className="benefit-card dark">
            <h3>Providing Service in English or Spanish</h3>
            <p>Work with an electrician who speaks your language. Our bilingual team ensures clear communication throughout your project.</p>
          </div>
          
          <div className="benefit-card light">
            <h3>Licensed & Insured Pros</h3>
            <p>Entrust your electrical needs to licensed, insured professionals. We prioritize safety and compliance with all electrical codes.</p>
          </div>
          
          <div className="benefit-card dark">
            <h3>Ask About Our Warranty</h3>
            <p>Get peace of mind with our warranty-backed services. We stand behind our work with guarantees you can trust.</p>
          </div>
        </div>
        
        <div className="cta-container">
          <a href="/contact" className="contact-button">Contact Us</a>
        </div>
      </section>

      {/* Main About Content */}
      <div className="content-with-image">
        <section className="about-content">
          <div className="about-text-section">
            <div className="section-label">About Us</div>
            <h2>Outstanding Residential & Commercial Services</h2>
            <p>At Escudero Electrical Contractors LLC, our family-owned business brings over 30 years of experience to every electrical installation and repair. All our services come with a 100% satisfaction guarantee. Our expert electricians are equipped to handle everything from simple light bulb changes to complex commercial and industrial electrical installations.</p>
            <p>We are committed to ensuring that your electrical needs are met with the highest standards of quality and the most effective solutions, ensuring complete satisfaction for every client we serve.</p>
            
          </div>
        </section>
      </div>

      {/* What Sets Us Apart Section */}
      <section className="what-sets-us-apart">
        <h2>What Sets Us Apart</h2>
        <p className="subtitle">A Small Team That Knows the Work</p>
        
        <div className="advantages-container">
          <div className="advantage">
            <h3>Family-Owned Business</h3>
            <p>We're not a big operation, and that's by design. When you call Escudero Electrical Contractors, you get experienced help without the layers. That means faster service, better communication, and a direct line to the people doing the work.</p>
          </div>
          
          <div className="advantage">
            <h3>Fast, Clear Scheduling</h3>
            <p>We offer same-day service when our schedule allows, and we do everything we can to keep waiting times short. We'll give you a clear timeline and talk about the job before we begin.</p>
          </div>
          
          <div className="advantage">
            <h3>Transparent Pricing</h3>
            <p>We keep our pricing competitive and walk you through every part of the job. All our work comes backed by a warranty on both parts and labor, ensuring you have peace of mind long after we complete the job.</p>
          </div>
          
          <div className="advantage">
            <h3>Safety First</h3>
            <p>At the core of our service philosophy lies a commitment to safety and precision in every task we undertake. We diligently adhere to the highest standards of safety protocols to protect our valued electricians and, most importantly, to ensure the well-being of you and your residence.</p>
          </div>
        </div>
        
        <div className="serving-area">
          <h3>Proudly Serving the Greater Chicagoland Area</h3>
          <p>From Naperville to Schaumburg, Bolingbrook to Palos Hills, and everywhere in between, our team is ready to serve your community with expert electrical services.</p>
        </div>
      </section>

      {/* Mission Section */}
      <div className="content-with-image">
        <section className="about-mission">
          <h2>Our Mission</h2>
          <p>Our mission is to set the standard for excellence in electrical services. With meticulous attention to detail and a steadfast commitment to client satisfaction, we are committed to not only resolving your electrical issues but also ensuring you have a clear understanding of the solutions we provide.</p>
          <p>Trust in us to illuminate the path to secure and efficient electrical solutions, as we believe informed clients are empowered clients. Each project is executed with an unwavering focus on delivering secure and reliable electrical solutions, affirming our dedication to your peace of mind.</p>
        </section>
      </div>
    </div>
  );
};

export default About;